import { Menu } from "@headlessui/react";
import { Trans } from "@lingui/macro";
import copy from "img/ic_copy_16.svg";
import externalLink from "img/ic_new_link_16.svg";
import disconnect from "img/ic_sign_out_16.svg";
import { helperToast } from "lib/helperToast";
import { shortenAddress } from "lib/legacy";
import { FaChevronDown } from "react-icons/fa";
import { createBreakpoint, useCopyToClipboard } from "react-use";
import "./AddressDropdown.css";
import ExternalLink from "components/ExternalLink/ExternalLink";
import Jazzicon from "react-jazzicon";

type Props = {
  account: string;
  accountUrl: string;
  disconnectAccountAndCloseSettings: () => void;
  punkUrl: any;
};

function AddressDropdown({ account, accountUrl, disconnectAccountAndCloseSettings, punkUrl }: Props) {
  const useBreakpoint = createBreakpoint({ L: 600, M: 550, S: 400 });
  const breakpoint = useBreakpoint();
  const [, copyToClipboard] = useCopyToClipboard();
  const modifierPunkUrl = punkUrl ?  "https://back.metis.market/0xc03085ba7e3c2a6c054a738dcfc16e8390a2c26b/pictures/" + punkUrl.split('/').slice(-1)[0] + ".jpg" : "";

  return (
    <Menu>
      <Menu.Button as="div">
        <button className="transparent address-btn">
          <div className="user-avatar">
            {modifierPunkUrl == "" ? 
            <Jazzicon diameter={21} seed={parseInt(account.slice(2, 10), 16)} />
            : <img className="punk" src={modifierPunkUrl} width="21px" />
            }
          </div>
          <span className="user-address">{shortenAddress(account, breakpoint === "S" ? 9 : 13)}</span>
          <FaChevronDown />
        </button>
      </Menu.Button>
      <div>
        <Menu.Items as="div" className="menu-items">
          <Menu.Item>
            <div
              className="menu-item"
              onClick={() => {
                copyToClipboard(account);
                helperToast.success("Address copied to your clipboard");
              }}
            >
              <img src={copy} alt="Copy user address" />
              <p>
                <Trans>Copy Address</Trans>
              </p>
            </div>
          </Menu.Item>
          <Menu.Item>
            <ExternalLink href={accountUrl} className="menu-item">
              <img src={externalLink} alt="Open address in explorer" />
              <p>
                <Trans>View in Explorer</Trans>
              </p>
            </ExternalLink>
          </Menu.Item>
          <Menu.Item>
            <div className="menu-item" onClick={disconnectAccountAndCloseSettings}>
              <img src={disconnect} alt="Disconnect the wallet" />
              <p>
                <Trans>Disconnect</Trans>
              </p>
            </div>
          </Menu.Item>
        </Menu.Items>
      </div>
    </Menu>
  );
}

export default AddressDropdown;
